var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { getViewDate, isValidDateValue, getDateFromIsoString, isRangeMode, formatToISO, } from '../../utils';
import { Months } from './views/months';
import { CalendarMobileView } from './views/calendar';
export var CalendarMobile = function (props) {
    var value = props.value, _a = props.minValue, minValue = _a === void 0 ? '' : _a, _b = props.maxValue, maxValue = _b === void 0 ? '' : _b, onSelectDate = props.onSelectDate, _c = props.outputDateFormat, outputDateFormat = _c === void 0 ? "yyyy-MM-dd'T'HH:mm:ss'Z'" : _c, multiselect = props.multiselect, readonly = props.readonly;
    var _d = useState(getViewDate(value, minValue, maxValue)), viewDate = _d[0], setViewDate = _d[1];
    var viewYear = viewDate.getFullYear();
    var minDate = getDateFromIsoString(minValue);
    var maxDate = getDateFromIsoString(maxValue);
    var selectedDate = isRangeMode(value)
        ? value.map(getDateFromIsoString)
        : getDateFromIsoString(value);
    useEffect(function () {
        if (isValidDateValue(value, minDate, maxDate)) {
            var updatedViewDate = getViewDate(value, minValue, maxValue);
            setViewDate(updatedViewDate);
        }
    }, [value]);
    var handleSelectDay = function (day, month, year) {
        if (readonly)
            return;
        var newDate = new Date(Date.UTC(year, month, day));
        var toFormatedISO = function (date) { return formatToISO(date, outputDateFormat); };
        var newDateISO = toFormatedISO(newDate);
        if (isRangeMode(selectedDate)) {
            if (multiselect) {
                var newMultipleDates = void 0;
                var validSelectedDate = selectedDate.filter(function (date) { return date !== null; });
                var indexDate = validSelectedDate.findIndex(function (date) { return date.getTime() === newDate.getTime(); });
                if (indexDate === -1) {
                    newMultipleDates = __spreadArray(__spreadArray([], validSelectedDate, true), [newDate], false);
                }
                else {
                    validSelectedDate.splice(indexDate, 1);
                    newMultipleDates = __spreadArray([], validSelectedDate, true);
                }
                onSelectDate === null || onSelectDate === void 0 ? void 0 : onSelectDate(newMultipleDates.map(toFormatedISO));
                return;
            }
            var newDateRange = void 0;
            var isFilledRange = Boolean(selectedDate[1]);
            var isStartedRange = Boolean(selectedDate[0]);
            var startDate = selectedDate[0], endDate = selectedDate[1];
            var localizedStartDate = startDate ? toFormatedISO(startDate) : '';
            var localizedEndDate = endDate ? toFormatedISO(endDate) : '';
            if (!isStartedRange) {
                newDateRange = [newDateISO, ''];
            }
            else if (!isFilledRange) {
                /* В заполненном состоянии, обновляем:
                 * стартовую дату, если новое значение меньше выбранного диапазона или новая дата замыкает диапазон в дате окончания
                 * конечную дату, если новое значение больше выбранного диапазона или новая дата замыкает диапазон в дате начала
                 */
                newDateRange =
                    (startDate && newDate < startDate) ||
                        (endDate && newDate.getTime() === endDate.getTime())
                        ? [newDateISO, localizedEndDate]
                        : [localizedStartDate, newDateISO];
            }
            else {
                /* Устанавливаем выбранное значение даты как начало диапазона в случаях:
                 * диапазон пуст, отсутствует стартовая дата
                 * новое значение даты меньше стартовой даты
                 */
                newDateRange = [newDateISO, ''];
            }
            onSelectDate === null || onSelectDate === void 0 ? void 0 : onSelectDate(newDateRange);
        }
        else {
            onSelectDate === null || onSelectDate === void 0 ? void 0 : onSelectDate(newDateISO);
        }
    };
    return (React.createElement(CalendarMobileView, __assign({}, props, { viewYear: viewYear }),
        React.createElement(Months, { minDate: minDate, maxDate: maxDate, viewDate: viewDate, selectedDate: selectedDate, onSelectDay: handleSelectDay, multiselect: multiselect, readonly: readonly })));
};
